import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Prowhip from "./sections/Prowhip";
import CulinaryHub from "./sections/CulinaryHub";
import Gallery from "./sections/Gallery";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Prowhip />
      <CulinaryHub />
      <Gallery />
      <Footer />
    </div>;
}